import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { DangerousHTMLSpan } from 'ecs-react-components/dist/index.es';
import { messages } from './SecureMessages.i18n';
import SecureMessageReply from './SecureMessageReply';
import * as ACTIONS from '../../redux/modules/secure-message/actions/creators';
import { patchArchivedThread } from '../../redux/modules/secure-message/secure-message-middleware';
import { formatDisplayName, findSelectedThread } from './SecureMessagesConfig';

class ThreadMessages extends Component {
  componentDidUpdate() {
    this.viewPane.scrollTop = 0;
  }

  onReplyButtonClick = () => {
    this.props.dispatch(ACTIONS.showSecureMessageReplyItem(true));
  }

  onArchiveClick = () => {
    const { patientId, timeZone, timeZoneOffset, language, dispatch } = this.props;
    const archiveStatus = this.props.filter === 'Current' ? 'Archived' : 'Current';
    const expectedMessage = archiveStatus === 'Archived' ?
      'securemessagethreadarchived' : 'securemessagethreadunarchived';
    const threadId = archiveStatus === 'Archived' ?
      this.props.selectedThreadIndex : this.props.selectedArchivedThreadIndex;
    dispatch(patchArchivedThread(
      patientId,
      threadId,
      archiveStatus,
      expectedMessage,
      language,
      timeZone,
      timeZoneOffset))
      .then(
        () => {
          dispatch(ACTIONS.showSecureMessageReplyItem(false));
          dispatch(ACTIONS.secureMessageThreadSelected(null));
          dispatch(ACTIONS.secureMessageArchivedThreadSelected(null));
          dispatch(ACTIONS.secureMessageThreadClear());
          dispatch(ACTIONS.secureMessageListViewCompact(true));
        });
  }

  renderArchiveButton() {
    return (
       <button type="button" className="btn btn-link icon-only float-right"
         onClick={this.onArchiveClick}
       >
            <span className="fa fa-archive" aria-hidden="true"></span>
            <span className="hidden-xs hidden-sm">
            {
              this.props.filter === 'Current' ?
                (<FormattedMessage { ...messages.link.archive } />) :
                (<FormattedMessage { ...messages.link.unarchive } />)
            }
            </span>
       </button>
    );
  }

  renderReplyButton() {
    if (this.props.filter === 'Current') {
      return (
        <button type="button" className="btn btn-link icon-only float-right" onClick={ this.onReplyButtonClick } >
            <span className="fa fa-reply" aria-hidden="true"></span>
            <span className="hidden-xs hidden-sm">
              <FormattedMessage { ...messages.link.reply } />
            </span>
        </button>);
    }
    return null;
  }

  renderMessagesContentZeroStatePane() {
    return (
      <div className="custom-list-wrapper" >
        <div
          className="view-pane"
          ref={ (divViewPane) => { this.viewPane = divViewPane; } }
        >
          <div className="zero-state-container">
            <div className="zero-state-content">
              <span className="fa fa-envelope-o"></span>
              <span>
                  <FormattedMessage { ...messages.page.initialStateMessage } />
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      selectedThread,
    } = this.props;

    return (
      selectedThread ?
      <div className="col-md-8 custom-list-wrapper">
          <div
            className="view-pane"
            ref={ (divViewPane) => { this.viewPane = divViewPane; } }
          >
            <div className="message-header">
              <DangerousHTMLSpan
                className="message-subject-line"
                qaTag="ThreadSubjectInMessagePane"
                html={ selectedThread.subjectText }
              />
              { this.renderArchiveButton() }
              { selectedThread.replyAllowed ? this.renderReplyButton() : null }
            </div>
            <div className="custom-list-wrapper message-thread">
              <ul className="list-group custom-list" data-qa-container="MsgsInThread">
              <SecureMessageReply />
                  {
                    this.props.messages.map((message, msgIndex) =>
                      (
                      <li className="list-group-item" key={ msgIndex }>
                        <div className="message-date-box">
                          {
                            message.displayDate.timePart ?
                              <div className="message-date">{ message.displayDate.timePart }</div> :
                              null
                          }
                          {
                            message.displayDate.datePart ?
                              <div className="message-date">{ message.displayDate.datePart }</div> :
                              null
                          }
                        </div>
                        <span className="primary-text bold">
                          {
                            formatDisplayName(
                              {
                                firstName: message.authorFirstName,
                                lastName: message.authorLastName,
                              },
                              {
                                firstName: message.proxyAuthorFirstName,
                                lastName: message.proxyAuthorLastName,
                              }
                            )
                          }
                        </span>
                        <DangerousHTMLSpan
                          className="secondary-text"
                          qaTag="messageContent"
                          html={ message.content }
                        />
                      </li>
                      ))
                  }
              </ul>
            </div>
          </div>
      </div> :
        this.renderMessagesContentZeroStatePane()
    );
  }
}

ThreadMessages.propTypes = {
  messages: PropTypes.array,
  dispatch: PropTypes.func,
  filter: PropTypes.string,
  timeZone: PropTypes.string,
  timeZoneOffset: PropTypes.string,
  language: PropTypes.string,
  patientId: PropTypes.number,
  selectedThreadIndex: PropTypes.number,
  selectedArchivedThreadIndex: PropTypes.number,
  selectedThread: PropTypes.object,
};

const mapStateToProps = (state) => ({
  filter: state.secureMessage.filter,
  patientId: state.profile.patient.patientId,
  timeZone: state.facility.timeZoneAbbreviation,
  timeZoneOffset: state.facility.timeZoneOffset,
  language: state.language.languageCode,
  selectedThreadIndex: state.secureMessage.selectedThreadIndex,
  selectedArchivedThreadIndex: state.secureMessage.selectedArchivedThreadIndex,
  selectedThread: findSelectedThread(state.secureMessage),
});

export default connect(mapStateToProps)(ThreadMessages);